import { Button } from "@/components/ui/button";
import { MESSAGE } from "@/constants/message";
import { DatasetsMap } from "@/types/dataset";
import { ScoringOptions } from "@/types/spatial";

import { twMerge } from "tailwind-merge";

import { TEST_ID_PREFIX } from "../analysisJobList";

interface WeightSummarySectionProps {
  availableDatasets: DatasetsMap;
  totalAttributes: number;
  hasWeightValuesChanged: boolean;
  resetAllWeights: () => void;
  selectedScoringOption: ScoringOptions | null;
  handleSaveSetting: () => void;
  isAllAttributeWeightZero: boolean;
  isAllDatasetWeightZero: boolean;
  isSaveDisabled?: boolean;
  className?: string;
}
export default function WeightSummarySection({
  availableDatasets,
  totalAttributes,
  hasWeightValuesChanged,
  resetAllWeights,
  handleSaveSetting,
  selectedScoringOption,
  isAllAttributeWeightZero,
  isAllDatasetWeightZero,
  isSaveDisabled = false,
  className
}: Readonly<WeightSummarySectionProps>) {
  return (
    <div
      className={twMerge(
        "flex flex-col items-center bg-white p-4 pt-2",
        className
      )}
    >
      <div className="bg-gray-50 rounded-lg p-3 w-full">
        <div className="flex justify-between mb-2">
          <span className="text-xs text-txtBody">Total Dataset</span>
          <span className="text-txtBody text-xs">
            {Object.values(availableDatasets).length}
          </span>
        </div>
        <div className="flex justify-between mb-2">
          <span className="text-xs text-txtBody">Total Attributes</span>
          <span className="text-txtBody text-xs">{totalAttributes}</span>
        </div>
        <div className="flex justify-between mb-2 border-t border-gainsboro pt-3 ">
          <span className="text-xs text-txtBody">Total Weight Percentage</span>
          <span
            className="text-txtHeading font-semibold"
            data-testid="total-weight-percentage"
          >
            100%
          </span>
        </div>
        <Button
          className="
            h-[32px] w-full py-1 mt-3 text-sm font-semibold
            disabled:border-gainsboro disabled:text-white
          "
          disabled={!hasWeightValuesChanged}
          onClick={resetAllWeights}
        >
          <span>Reset to Default</span>
        </Button>
        {isAllAttributeWeightZero && (
          <div className="text-red-600 text-[10px] w-full text-center mt-2">
            {MESSAGE.SETTING_WEIGHT_VALUES_INVALID}
          </div>
        )}
      </div>
      {/* Footer */}
      <Button
        disabled={
          !selectedScoringOption ||
          isAllAttributeWeightZero ||
          isAllDatasetWeightZero ||
          isSaveDisabled
        }
        className={twMerge(
          "w-full mx-4 mt-2 border bg-teal-500 text-white text-sm font-bold",
          "disabled:border-none disabled:bg-gainsboro disabled:text-white"
        )}
        onClick={handleSaveSetting}
        data-testid={`${TEST_ID_PREFIX}-save-button`}
      >
        <span>Save</span>
      </Button>
    </div>
  );
}
